<template>
  <template v-if="isLoaded()">
    <div class="card">
      <div class="table-responsive">
          <table class="table table-vcenter card-table">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Авторизация</th>
                <th>События</th>
                <th>Уведомления</th>
                <th>Посты</th>
                <th>Ресурсы</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in fields.items" :key="item['stat_date']">
                <td class="text-secondary"><span class="val">{{ item["stat_date"] }}</span></td>
                <td class="text-secondary"><span class="val">{{ item["auth"]["cnt_user_activate"] }}</span></td>
                <td class="text-secondary">
                  <b>Всего:</b> <span class="val">{{ item["event"]["cnt_event"] }}</span><br>
                  <b>Прочитано</b>: <span class="val">{{ item["event"]["cnt_event_read"] }}</span>
                </td>
                <td class="text-secondary">
                  <b>Всего:</b> <span class="val">{{ item["notify"]["cnt_notify"] }}</span><br>
                  <b>Прочитано:</b> <span class="val">{{ item["notify"]["cnt_notify_read"] }}</span><br>
                  <b>Отправлено в Telegram:</b> <span class="val">{{ item["notify"]["cnt_notify_telegram"] }}</span>
                </td>
                <td class="text-secondary">
                  <b>Лайков:</b> <span class="val">{{ item["post"]["cnt_post_like"] }}</span><br>
                  <b>Дизлайков:</b> <span class="val">{{ item["post"]["cnt_dislike"] }}</span><br>
                  <b>Дров:</b> <span class="val">{{ item["post"]["cnt_res_like"] }}</span><br>
                  <b>Воды:</b> <span class="val">{{ item["post"]["cnt_res_dislike"] }}</span>
                </td>
                <td class="text-secondary">
                  <span class="val">{{ item["resource"]["cnt_generate"] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  </template>
  <template v-if="isLoading()">
    <div class="text-center p-1">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </template>
</template>

<script>
import {defineComponent, onMounted, reactive, watch, ref} from "vue"
import Api from "./services/Api"
import Notify from "@/services/Notify";

export default defineComponent({
  components: {},
  name: "Common",
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const fields = reactive({
      items: "",
    })

    let loading = ref(false)

    onMounted(async () => {
      try {
        let cntDays = 7

        const [auth, event, notify, post, resource] = await Promise.all([
          Api.auth(cntDays),
          Api.event(cntDays),
          Api.notify(cntDays),
          Api.post(cntDays),
          Api.resource(cntDays),
        ])

        const result = mergeDataByDate({
          "auth": auth,
          "event": event,
          "notify": notify,
          "post": post,
          "resource": resource,
        });

        updateFields({
          "items": result,
        })

        loading.value = true
      } catch (error) {
        console.error("Произошла ошибка при выполнении запросов:", error)

        Notify.error("Произошла ошибка при выполнении запроса")
      }
    })

    function mergeDataByDate(datasets) {
      const mergedMap = {};

      Object.entries(datasets).forEach(([sectionName, dataArray]) => {
        if (!Array.isArray(dataArray)) return;

        dataArray.forEach((item) => {
          const date = item.stat_date;
          if (!date) return;

          if (!mergedMap[date]) {
            mergedMap[date] = {
              stat_date: date
            };
          }

          if (!mergedMap[date][sectionName]) {
            mergedMap[date][sectionName] = {};
          }

          const metrics = { ...item };
          delete metrics.stat_date;

          mergedMap[date][sectionName] = {
            ...mergedMap[date][sectionName],
            ...metrics
          };
        });
      });

      return Object.values(mergedMap).sort((a, b) =>
          new Date(b.stat_date) - new Date(a.stat_date)
      );
    }

    watch(() => props.payload, (val) => {
      updateFields(val)
    }, {
      immediate: true,
    })

    function updateFields(query) {
      fields.items = query.items
    }

    function isLoading() {
      return loading.value === false
    }

    function isLoaded() {
      return loading.value === true
    }

    return {
      fields,
      isLoading,
      isLoaded,
    }
  },
})
</script>

<style src="./css/style.css" scoped></style>
